import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const deleteOrganisation = async (id: string): Promise<void> => {
  // yes, you need to pass the id in the url before the resource name
  const response = await axiosClient.delete(`${id}/organisations`);
  return response.data;
};

export function useDeleteOrganisation(
  queryOptions?: UseMutationOptions<void, HttpError, { id: string }>,
) {
  return useMutation({
    mutationFn: ({ id }) => deleteOrganisation(id),
    ...queryOptions,
  });
}
